import React from "react"
import FaqItem from "./FaqItem"
import '../../assets/stylesheets/quests.scss'

const FAQ = ({items}) => {

    return (
        <>
            {items.map((item, index) => {
                return (
                    <FaqItem key={`terms-${index}`} item={item} index={index} />
                )
            })}
        </>
    )
}

export default FAQ